/* eslint-disable camelcase */
import _ from 'lodash'
import getInitState from './get-init-state.js'
import { Base64 } from 'js-base64'
import { generateGameConfigResource, generateI18nResource } from '../common'
import getOutlineCategory from '@/store/creative/template/get-outline-category'
import { language } from '@/common/storage'
import Vue from 'vue'

export default {
  updateTemplateConfig(state, conf) {
    state.templateConfig = conf
  },

  updateJsonConfig(state, value) {
    state.templateConfig.json_config = {
      ...state.templateConfig.json_config,
      ...value,
    }
  },

  updateTemplateConfigName(state, name) {
    state.templateConfig.name = name
  },

  updateTemplateCategory(state, value) {
    state.templateConfig.category = value
  },

  updatePreviewUrl(state, url) {
    url = url.indexOf('?') > -1 ? url + '&' : url + '?'
    state.previewUrl = `${url}preview=true&mw_test=0&loading=1&random=${
      new Date().getTime() * Math.random()
    }`
  },

  updatePageId(state, id) {
    state.id = Number(id)
  },

  addValidator(state, { name, validate }) {
    // console.log(`验证组件${name}`, validate)
    if (typeof validate === 'function') {
      state.validateList.push({ name, validate })
    } else {
      console.error('validate 不是一个函数')
    }
  },

  emptyValidator(state) {
    state.validateList = []
  },

  resetState(state) {
    Object.assign(state, getInitState())
  },

  updateGameDifficulty(state, val) {
    state.gameDifficulty = val
  },

  updateCurrentCategory(state, val) {
    state.currentCategory = val
  },

  openCloudResourcesDialog(state) {
    state.cloudResourcesDialog.visible = true
  },

  closeCloudResourcesDialog(state) {
    state.cloudResourcesDialog.visible = false
  },

  /**
   * openAddRepositoryResourceDialog
   * @param state
   * @param {{action: string}} param1，action 是操作行为，可选值是 add 或 update
   */
  openAddRepositoryResourceDialog(state, { action }) {
    state.addRepositoryResourceDialog.visible = true
    state.addRepositoryResourceDialog.action = action || 'add'
  },

  closeAddRepositoryResourceDialog(state) {
    state.addRepositoryResourceDialog.visible = false
  },

  /**
   * openAddLocalResourceDialog
   * @param state
   * @param {{action: string}} param1，action 是操作行为，可选值是 add 或 update
   */
  openAddLocalResourceDialog(state, { action }) {
    state.addLocalResourceDialog.visible = true
    state.addLocalResourceDialog.action = action || 'add'
  },

  closeAddLocalResourceDialog(state) {
    state.addLocalResourceDialog.visible = false
  },

  updateCurrentResourceInZip(state, resource) {
    state.currentResourceInZip = resource
  },

  openAddLocalResourceInZipDialog(state) {
    state.addLocalResourceInZipDialog.visible = true
  },

  closeAddLocalResourceInZipDialog(state) {
    state.addLocalResourceInZipDialog.visible = false
  },

  openMenuTransferDialog(state) {
    state.menuTransferDialog.visible = true
  },

  closeMenuTransferDialog(state) {
    state.menuTransferDialog.visible = false
  },

  updateActiveCategoryId(state, id) {
    state.activeCategoryId = id
  },

  updateActiveCategoryNode(state, node) {
    state.activeCategoryNode = node
  },

  // 更新当前编辑的资源，并不是编辑资源本身
  updateCurrentResource(state, val) {
    state.currentResource = val
  },

  updateCurrentResourceGroupTop(state, val) {
    state.currentResourceGroupTop = val
  },

  openEditResourceDialog(state) {
    state.editResourceDialog.visible = true
  },

  closeEditResourceDialog(state) {
    state.editResourceDialog.visible = false
  },

  setEditResourceDialogClosable(state, val) {
    state.editResourceDialog.closable = val
  },

  /**
   * updatePage 更细页面类型
   * @param {any} state
   * @param {string} value
   */
  updatePage(state, value) {
    state.page = value
  },

  /**
   * updateStars 更新收藏
   * @param {any} state
   * @param {{type: string, category: string|number}} param1
   */
  updateStars(state, { type, category }) {
    const starsConfig = _.cloneDeep(state.starsConfig)
    let currentStars = starsConfig[type] || []
    const isAddStar = !currentStars.some((val) => val === category)

    if (isAddStar) {
      // 添加收藏
      currentStars.push(category)
    } else {
      // // 移除收藏
      currentStars = _.difference(currentStars, [category])
    }
    starsConfig[type] = currentStars

    state.starsConfig = starsConfig
  },

  /**
   * updatePermissions 更新当前页面的权限
   * @param {any} state
   * @param {string[]} value
   */
  updatePermissions(state, value) {
    state.permissions = value
  },

  updateSortMenuDialog(state, value) {
    state.sortMenuDialog = {
      ...state.sortMenuDialog,
      ...value,
    }
    // 隐藏 previewer，保证拖拽事件正常
    // https://confluence.mobvista.com/pages/viewpage.action?pageId=49618006
    const previewer = document.querySelector('.web-previewer-bd')
    previewer &&
      (previewer.style.display = `${value.visible ? 'none' : 'block'}`)
  },

  /**
   * updateCurrentLanguage 更新当前语言
   * @param {any} state
   * @param {string} value
   */
  updateCurrentLanguage(state, value) {
    state.currentLanguage = value
  },

  /**
   * updatePreviewLanguage 更新当前预览语言
   * @param {any} state
   * @param {string} value
   */
  updatePreviewLanguage(state, value) {
    state.previewLanguage = value
  },

  /**
   * updatePreviewLanguageList 更新当前预览语言
   * @param {any} state
   * @param {string[]} value
   */
  updatePreviewLanguageList(state, value) {
    state.previewLanguageList = value
  },

  /**
   * addPreviewLanguage
   * @param {any} state
   * @param {string} value
   */
  addPreviewLanguage(state, value) {
    const list = state.previewLanguageList

    if (list.every((item) => item !== value)) {
      list.push(value)
      state.previewLanguageList = list
    } else {
      console.warn('已有该语言')
    }
  },

  /**
   * removePreviewLanguage
   * @param {any} state
   * @param {string} value
   */
  removePreviewLanguage(state, value) {
    const list = state.previewLanguageList
    _.remove(list, (item) => item === value)
    state.previewLanguageList = list
  },

  /**
   * updateZipLangList 更新当前预览
   * @param {any} state
   * @param {string} value
   */
  updateZipLangList(state, value) {
    state.zipLangList = value
  },

  /**
   * updateOriginalJson
   * @param {any} state
   * @param {{}} value
   */
  updateOriginalJson(state, value) {
    state.originalJson = value
  },

  updateOriginalResources(state, value) {
    state.originalResources = value
  },

  /**
   * changeDefaultGameDifficulty 切换默认 gameConfig
   * @param {any} state
   * @param {{tag: string}} param1
   */
  changeDefaultGameDifficulty(state, { tag }) {
    state.gameConfigResource.gameDifficultyList.forEach((item) => {
      item.is_default = item.tag === tag
    })
  },

  /**
   * 初始化收藏
   * @param {any} state
   * @param {{}} value
   */
  initStars(state, value) {
    state.starsConfig = value
  },

  /**
   * canLivePreview
   * @param {any} state
   * @param {boolean} value
   */
  updateCanLivePreview(state, value) {
    state.canLivePreview = value
  },

  /**
   * updateHasJsonConfig
   * @param {any} state
   * @param {boolean} value
   */
  updateHasJsonConfig(state, value) {
    state.hasJsonConfig = value
  },

  /**
   * updateHasModelResource
   * @param {any} state
   * @param {boolean} value
   */
  updateHasModelResource(state, value) {
    state.hasModelResource = value
  },

  /**
   * updateRouter
   * @param {any} state
   * @param {{}} value
   */
  updateRouter(state, value) {
    state.router = value
  },

  /**
   * updateGameConfigResource
   * @param {any} state
   * @param {{}} value
   */
  updateGameConfigResource(state, value = {}) {
    state.gameConfigResource = value
  },

  /**
   * updateTargetGameConfigResource，更新游戏配置
   * @param {any} state
   * @param {{key: string, value: {}}} param1
   * @param key 当前配置的 key
   * @param value 当前配置新的值
   */
  updateTargetGameConfigResource(state, { key, value }) {
    const gameConfigResource = _.cloneDeep(state.gameConfigResource)

    if (!_.isUndefined(_.get(gameConfigResource, key))) {
      _.set(gameConfigResource, key, value)
      state.gameConfigResource = gameConfigResource
    } else {
      console.warn(`gameConfigResource 没有找到 ${key}`)
    }
  },

  /**
   * updateGameDifficultyInGameConfigResource，更新难度模式的玩法内容（如 dco 多难度配置/多组合多难度配置）
   * @param {any} state
   * @param {{key: string, value: {}, index: number}} param1
   * @param index 当前配置的索引
   * @param key 当前配置的 key
   * @param value 当前配置新的值
   */
  updateGameDifficultyInGameConfigResource(state, { key, value, index }) {
    const gameConfigResource = state.gameConfigResource
    const gameDifficultyList = gameConfigResource.gameDifficultyList
    const currentGameDifficulty = _.get(gameDifficultyList[index].data, key)

    if (currentGameDifficulty) {
      // 不要直接 _.set(gameDifficultyList[0].data, key, value)，如果是自定义数组子项的话，无法联动更新界面
      const data = _.cloneDeep(_.get(gameDifficultyList, `[${index}].data`))
      _.set(data, key, {
        ...currentGameDifficulty,
        ..._.cloneDeep(value),
      })
      gameDifficultyList[index].data = data
      state.gameConfigResource.gameDifficultyList = gameDifficultyList
    } else {
      console.warn(
        `gameConfigResource.gameDifficultyList[${index}] 没有找到 ${key}`,
      )
    }
  },

  /**
   * addCategoryGameConfigResource，添加分类游戏配置
   * @param {any} state
   * @param {{category: {prefix: string, id: number, name: string}, config: {}}} param0
   */
  addCategoryGameConfigResource(state, { category, config }) {
    let list = state.gameConfigResource[category.prefix]
    const newGameConfig = generateGameConfigResource({
      category_id: category.id,
      name: `${category.name}`,
      prefix: category.prefix,
      data: _.cloneDeep(config),
    })

    list.push(newGameConfig)
    list = list.map((item, index) => ({
      ...item,
      name: `${category.name}-${index + 1}`,
    }))
    state.gameConfigResource[category.prefix] = list
  },

  /**
   * removeCategoryGameConfigResource，删除分类游戏配置
   * @param {any} state
   * @param {{category: {prefix: string, id: number, name: string}, index: number}} param1
   */
  removeCategoryGameConfigResource(state, { category, index }) {
    let list = state.gameConfigResource[category.prefix]
    list.splice(index, 1)
    list = list.map((item, index) => ({
      ...item,
      name: `${category.name}-${index + 1}`,
    }))
    state.gameConfigResource[category.prefix] = list
  },

  /**
   * updateI18nResource
   * @param {any} state
   * @param {{}} value
   */
  updateI18nResource(state, value = {}) {
    state.i18nResource = value
  },

  /**
   * addI18nResource，添加代码字坑位配置
   * @param {any} state
   * @param {{category: {prefix: string, id: number, name: string}, config: {}}} param0
   */
  addI18nResource(state, { category, config }) {
    const encodePrefix = Base64.encode(category.prefix)
    let list = state.i18nResource[encodePrefix]
    const newI18n = generateI18nResource({
      category_id: category.id,
      name: `${category.name}`,
      prefix: category.prefix,
      data: _.cloneDeep(config),
    })

    list.push(newI18n)
    list = list.map((item, index) => ({
      ...item,
      name: `${category.name}-${index + 1}`,
      name_en: `${category.name_en || category.name}-${index + 1}`,
    }))
    state.i18nResource[encodePrefix] = list
  },

  /**
   * addI18nResource，添加代码字坑位配置
   * @param {any} state
   * @param {{category: {prefix: string, id: number, name: string}}} param0
   */
  removeI18nResource(state, { category, index }) {
    const encodePrefix = Base64.encode(category.prefix)
    let list = state.i18nResource[encodePrefix]
    list.splice(index, 1)
    list = list.map((item, index) => ({
      ...item,
      name: `${category.name}-${index + 1}`,
      name_en: `${category.name_en || category.name}-${index + 1}`,
    }))
    state.i18nResource[encodePrefix] = list
  },

  /**
   * updateTargetI18nResource
   * @param state {}
   * @param key {string}
   * @param value {{value: string|number, style: {}}}
   * @param index {number}
   * @param language {string}
   */
  updateTargetI18nResource(state, { key, value, index, language }) {
    const i18nResource = state.i18nResource
    if (!_.isUndefined(i18nResource[key])) {
      const list = i18nResource[key]
      const oldData = list[index].data[language]
      list[index].data[language] = { ...oldData, ...value }
      state.i18nResource[key] = list
      // 更新 templateConfig.json_config.i18n 里面的数据
      if (
        state.templateConfig &&
        state.templateConfig.json_config &&
        state.templateConfig.json_config.i18n &&
        state.templateConfig.json_config.i18n.languages &&
        state.templateConfig.json_config.i18n.languages[language] &&
        state.templateConfig.json_config.i18n.languages[language][key]
      ) {
        const oldData =
          state.templateConfig.json_config.i18n.languages[language][key]
        state.templateConfig.json_config.i18n.languages[language][key] = {
          ...oldData,
          ...value,
        }
      } else {
        console.error(
          '没有找到对应 json_config.i18n 的代码字坑位，存在异常数据',
        )
      }
    } else {
      console.error('没有找到对应的代码字坑位，存在异常数据')
    }
  },

  /**
   * updateNotSceneI18nResource
   * @param state {}
   * @param key {string}
   * @param value {{value: string|number, style: {}}}
   * @param language {string}
   */
  updateNotSceneI18nResource(state, { key, value, language }) {
    // 更新 templateConfig.json_config.i18n 里面的数据
    if (
      state.templateConfig &&
      state.templateConfig.json_config &&
      state.templateConfig.json_config.i18n &&
      state.templateConfig.json_config.i18n.languages &&
      state.templateConfig.json_config.i18n.languages[language] &&
      state.templateConfig.json_config.i18n.languages[language][key]
    ) {
      const oldData =
        state.templateConfig.json_config.i18n.languages[language][key]
      state.templateConfig.json_config.i18n.languages[language][key] = {
        ...oldData,
        ...value,
      }
    } else {
      console.error('没有找到对应 json_config.i18n 的代码字坑位，存在异常数据')
    }
  },

  /**
   * updateGroupsConfig
   * @param state {any}
   */
  updateOutlineCategory(state) {
    const category = getOutlineCategory({
      category: state.templateConfig.category,
      isDco: false,
      templateConfig: state.templateConfig,
      gameConfigResource: state.gameConfigResource,
      isCommonTemplateCustom: state.isCommonTemplateCustom,
      foldCategoryList: state.foldCategoryList,
      permissionKeys: state.permissions,
    })
    state.outline.category = category
  },

  /**
   * 折叠 category
   * @param {any} state
   * @param {{id: number, isFold: boolean}} node
   */
  foldOutlineCategory(state, node) {
    if (node.isFold) {
      state.foldCategoryList = state.foldCategoryList.filter(
        (item) => item !== node.id,
      )
    } else {
      state.foldCategoryList = _.uniq([...state.foldCategoryList, node.id])
    }
    console.log(state.foldCategoryList)
  },

  /**
   * updatePreviewGroupConfig，更新当前预览组合配置
   * @param {any} state
   * @param {string} value
   */
  updatePreviewGroupConfig(state, value = state.previewGroup) {
    state.previewGroup = value
    state.previewGroupConfig = state.groupsConfig.find(
      (item) => item.name === state.previewGroup,
    )

    // 根据组合的信息更新资源的 is_default 属性
    const currentGroupResourceList =
      _.get(state.previewGroupConfig, 'resource.list') || []
    _.each(currentGroupResourceList, (resource) => {
      const currentCategoryResourceList = _.get(
        state,
        `templateConfig.resource.${resource.category_id}`,
      )
      _.each(currentCategoryResourceList, (innerRes) => {
        if (innerRes.id === resource.id) {
          innerRes.is_default = 1
        } else {
          innerRes.is_default = 0
        }
      })
    })
  },

  /**
   * updateCurrentTab
   * @param {any} state
   * @param {number} id
   */
  updateCurrentTab(state, id) {
    state.currentTab = id
  },

  /**
   * updateTemplateState
   * @param {any} state
   * @param {string} val
   */
  updateTemplateState(state, val) {
    state.templateState = val
  },

  updateReadonly(state, val) {
    state.isReadonly = val
  },

  // 锁定页面
  lock(state) {
    state.isLock = true
    state.isReadonly = true
  },

  // 解锁页面
  unLock(state) {
    state.isLock = false
    state.isReadonly = false
  },

  updatePreparingPreview(state, value) {
    state.preparingPreview = value
  },

  updateMwConfig(state, value) {
    state.templateConfig.mw_config = {
      ...state.templateConfig.mw_config,
      ...value,
    }
  },

  updateSkinId(state, value) {
    state.skinId = Number(value)
  },

  /**
   * 更新玩法分类配置
   * @param state
   * @param key {string}
   * @param value {{ name: string, desc: string, name_en: string, desc_en: string, options_en: array }}
   */
  updateTargetPlayConfig(state, { key, value }) {
    // 为啥不直接赋值value, 因为如果赋值 value 的话，会让 name 也会改成英文版本的内容
    let newValue = {}
    // 为啥要有这个逻辑，因为 en 环境下，name 就是 name_en，desc 就是 desc_en, 需要赋值过去，否则会丢失
    // 另外需要兼容 option_en 的场景
    if (language.get() === 'en') {
      if (
        typeof value.name !== 'undefined' &&
        typeof value.name_en === 'undefined'
      ) {
        newValue.name_en = value.name
      } else if (typeof value.name_en !== 'undefined') {
        newValue.name_en = value.name_en
      }
      if (
        typeof value.desc !== 'undefined' &&
        typeof value.desc_en === 'undefined'
      ) {
        newValue.desc_en = value.desc
      } else if (typeof value.desc_en !== 'undefined') {
        newValue.desc_en = value.desc_en
      }
      if (typeof value.options_en !== 'undefined') {
        newValue.options_en = value.options_en
      }
      if (typeof value.options !== 'undefined') {
        newValue.options = value.options
      }
      if (typeof value.unit !== 'undefined') {
        newValue.unit = value.unit
      }
      if (typeof value.unit_en !== 'undefined') {
        newValue.unit_en = value.unit_en
      }
    } else {
      newValue = value
    }
    const playConfig = state.templateConfig.play_config
    playConfig.gameConfig[key] = {
      ...playConfig.gameConfig[key],
      ...newValue,
    }
    Vue.set(state.templateConfig, 'play_config', playConfig)
  },

  updateEditorI18nStore(state, { key, value }) {
    const playConfig = state.templateConfig.play_config
    const i18nStore =
      playConfig.editorConfig && playConfig.editorConfig.i18nStore
    if (i18nStore && i18nStore.length) {
      i18nStore.forEach((item) => {
        if (item.id === key) {
          item.labelEn = value
        }
      })
    }
    Vue.set(state.templateConfig, 'play_config', playConfig)
  },

  // 更新项目actions英文名称
  updateTemplateActionsEnName(state, { key, value }) {
    const actions = state.templateConfig.actions
    if (actions[key]) {
      actions[key]['en'] = value
    }
    Vue.set(state.templateConfig, 'actions', actions)
  },

  updateVersion(state, val) {
    state.version = val
    state.isV2 = state.version === 2
  },

  categoryListBackToTop() {
    const ele = document.getElementById('workspace-category-list')
    ele.scroll(0, 0)
  },

  updateOrientation(state, val) {
    state.orientation = val
  },

  updateDevice(state, val) {
    state.device = val
  },

  updateBindDemand(state, val) {
    Object.assign(state.bind_demand, val)
  },

  /**
   * updateI18nResourceByReplace
   * @param data {}
   */
  updateI18nResourceByReplace(state, data) {
    for (const key in state.i18nResource) {
      for (const tempKey in state.i18nResource[key]) {
        const tempItem = state.i18nResource[key][tempKey].data
        for (const i18nKey in tempItem) {
          const i18nLanguageItem = tempItem[i18nKey]
          if (
            _.has(data, i18nKey) &&
            _.has(data[i18nKey], i18nLanguageItem.style.font)
          ) {
            i18nLanguageItem.style.font =
              data[i18nKey][i18nLanguageItem.style.font]
          }
        }
      }
    }
  },

  /**
   * updateHasPresetResource
   * @param {any} state
   * @param {boolean} value
   */
  updateHasPresetResource(state, value) {
    state.hasPresetResource = value
  },

  updateMvPlayableState(state, value) {
    state.hasMvPlayable = value
  },

  /**
   * updateHasModelResource
   * @param {any} state
   * @param {boolean} value
   */
  updateHasCocosModel(state, value) {
    state.hasCocosModel = value
  },

  updateRefreshCover(state, value) {
    // 每次点击都要刷新值
    state.refreshCover = 0
    setTimeout(() => {
      state.refreshCover = value
    }, 100)
  },
}
